import React from 'react';
import { Box, Button } from '@mui/material';
import { Event as EventIcon, Add as AddIcon } from '@mui/icons-material';
import ResponsiveTitle from '../../components/ResponsiveTitle';
import { useAuth } from '../../contexts/AuthContext';
import { MEMBER_TYPES } from '../../types/User';

interface EventsHeaderProps {
  upcomingCount: number;
  onCreateClick: () => void;
}

const EventsHeader: React.FC<EventsHeaderProps> = ({ upcomingCount, onCreateClick }) => {
  const { user } = useAuth();

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      justifyContent: 'space-between',
      alignItems: { xs: 'flex-start', md: 'center' },
      gap: { xs: 2, md: 0 },
      mb: 3
    }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        bgcolor: 'rgba(0, 0, 0, 0.5)',
        borderRadius: 4,
        px: 3, // Padding standard
        py: 1,
        color: 'white',
        // FIX: Utilisation d'une marge à gauche pour décaler le titre après le bouton
        ml: { xs: 9, md: 0 },
        width: { xs: 'calc(100% - 90px)', md: 'fit-content' },
        maxWidth: '100%',
        boxSizing: 'border-box'
      }}>
        <EventIcon />
        <ResponsiveTitle variant="h4" component="h2" minFontSize={16} maxFontSize={34} style={{ fontWeight: 'bold' }}>
          {upcomingCount} Événement{upcomingCount > 1 ? 's' : ''} à venir
        </ResponsiveTitle>
      </Box>


    </Box>
  );
};

export default EventsHeader;
